<!-- header.component.html -->
<nav class="header bg-blue-850 dark:bg-gray-800">
  <div class="fm-icon-text ml-4 flex flex-row items-center">
    <img src="/assets/images/icon/fitmed-icon-coloured.svg" alt="FitMed Icon" class="h-8 w-8" />
    <span class="title-font-selector ml-4 text-sm text-white">
      {{ 'HeaderIconDesc' | localizeText : 'Actively making you better' | titlecase }}
    </span>
  </div>

  <div class="flex items-center space-x-2 p-1">
    <app-global-search-bar></app-global-search-bar>

    <app-region-selection
      [selectedRegion]="defaultRegion()"
      (regionSelected)="handleRegionChange($event)">
    </app-region-selection>

    <!-- Suggested region popup (auto-shown) -->
    @if (suggestedRegion(); as sr) {
      @if (suggestedRegionOpen()) {
        <div
          class="absolute right-4 top-14 z-50 w-[340px] overflow-hidden rounded-xl border border-zinc-800 bg-zinc-950/95 shadow-xl ring-1 ring-inset ring-zinc-700/40"
          role="dialog"
          aria-label="Suggested region"
        >
          <div class="flex items-start justify-between gap-3 border-b border-zinc-800 px-4 py-3">
            <div class="min-w-0">
              <p class="text-sm font-semibold text-zinc-100">Suggested region</p>
              <p class="mt-0.5 text-xs text-zinc-400">
                We detected a better region for this patient. Switch now for best performance.
              </p>
            </div>

            <button
              type="button"
              class="rounded-md p-1 text-zinc-400 hover:bg-zinc-900 hover:text-zinc-200"
              (click)="dismissSuggestedRegion()"
              aria-label="Close"
            >
              <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>

          <div class="px-4 py-3">
            <div class="rounded-lg bg-zinc-900/60 p-3 ring-1 ring-inset ring-zinc-800/60">
              <div class="flex items-start justify-between gap-3">
                <div class="min-w-0">
                  <p class="truncate text-sm font-medium text-zinc-100">
                    {{ sr.displayName }}
                  </p>
                  <p class="mt-0.5 text-xs text-zinc-400">
                    This will update your active region for this session.
                  </p>
                </div>
                <span class="inline-flex items-center rounded-full bg-amber-900/30 px-2 py-0.5 text-xs text-amber-200 ring-1 ring-inset ring-amber-800">
                  Recommended
                </span>
              </div>

              <div class="mt-3 flex items-center gap-2">
                <button
                  type="button"
                  (click)="applySuggestedRegion()"
                  class="inline-flex items-center justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-indigo-500"
                >
                  Switch region
                </button>

                <button
                  type="button"
                  (click)="dismissSuggestedRegion()"
                  class="inline-flex items-center justify-center rounded-md bg-zinc-800 px-3 py-1.5 text-sm font-medium text-zinc-200 ring-1 ring-inset ring-zinc-700 hover:bg-zinc-700"
                >
                  Not now
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    }

    <app-login-subj-bubble></app-login-subj-bubble>
  </div>
</nav>
